import React, { useState, useEffect } from 'react';
import Toggle from '../../../Common/Toggle/Toggle';
import { FaEdit, FaTrash } from 'react-icons/fa';
import '../Nucleos/Nucleos.css';

import API_BASE_URL from '../../../../config/api';
const OrgaoEspecialidades = () => {
  const [orgaoEspecialidades, setOrgaoEspecialidades] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({
    especialidade: '',
    ativo: true
  });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const carregarEspecialidades = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_URL}/orgao-especialidades`
      );

      if (!response.ok) {
        throw new Error('Erro ao buscar especialidades de órgão');
      }

      const data = await response.json();

      const formatadas = data.map((item) => ({
        id: item.id_especialidade,
        especialidade: item.nome_especialidade,
        ativo: item.ativo
      }));

      setOrgaoEspecialidades(formatadas);
    } catch (error) {
      console.error('Erro ao carregar especialidades de órgão:', error);
      alert(
        'Erro ao carregar especialidades de órgão. Verifique a conexão com o servidor.'
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarEspecialidades();
  }, []);

  const filteredOrgaoEspecialidades = orgaoEspecialidades.filter(
    (especialidade) =>
      especialidade.especialidade
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const payload = {
        nome_especialidade: formData.especialidade,
        ativo: formData.ativo
      };

      if (editingId) {
        const response = await fetch(
          `${API_BASE_URL}/orgao-especialidades/${editingId}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao atualizar especialidade de órgão');
        }

        const atualizado = await response.json();

        setOrgaoEspecialidades((prev) =>
          prev.map((especialidade) =>
            especialidade.id === editingId
              ? {
                  id: atualizado.id_especialidade,
                  especialidade: atualizado.nome_especialidade,
                  ativo: atualizado.ativo
                }
              : especialidade
          )
        );
      } else {
        const response = await fetch(
          `${API_BASE_URL}/orgao-especialidades`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao criar especialidade de órgão');
        }

        const criado = await response.json();

        setOrgaoEspecialidades((prev) => [
          ...prev,
          {
            id: criado.id_especialidade,
            especialidade: criado.nome_especialidade,
            ativo: criado.ativo
          }
        ]);
      }

      resetForm();
    } catch (error) {
      console.error('Erro ao salvar especialidade de órgão:', error);
      alert(
        'Erro ao salvar especialidade de órgão. Verifique os dados e tente novamente.'
      );
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = (especialidade) => {
    setFormData({
      especialidade: especialidade.especialidade,
      ativo: especialidade.ativo
    });
    setEditingId(especialidade.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (
      !window.confirm(
        'Tem certeza que deseja excluir esta especialidade?'
      )
    ) {
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/orgao-especialidades/${id}`,
        {
          method: 'DELETE'
        }
      );

      if (!response.ok && response.status !== 204) {
        throw new Error('Erro ao excluir especialidade de órgão');
      }

      setOrgaoEspecialidades((prev) =>
        prev.filter((especialidade) => especialidade.id !== id)
      );
    } catch (error) {
      console.error('Erro ao excluir especialidade de órgão:', error);
      alert('Erro ao excluir especialidade de órgão. Tente novamente.');
    }
  };

  const resetForm = () => {
    setFormData({ especialidade: '', ativo: true });
    setEditingId(null);
    setShowForm(false);
  };

  const handleToggleStatus = async (id) => {
    const especialidadeSelecionada = orgaoEspecialidades.find(
      (especialidade) => especialidade.id === id
    );

    if (!especialidadeSelecionada) {
      return;
    }

    const novoAtivo = !especialidadeSelecionada.ativo;

    try {
      const response = await fetch(
        `${API_BASE_URL}/orgao-especialidades/${id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            nome_especialidade: especialidadeSelecionada.especialidade,
            ativo: novoAtivo
          })
        }
      );

      if (!response.ok) {
        throw new Error(
          'Erro ao atualizar status da especialidade de órgão'
        );
      }

      const atualizado = await response.json();

      setOrgaoEspecialidades((prev) =>
        prev.map((especialidade) =>
          especialidade.id === id
            ? { ...especialidade, ativo: atualizado.ativo }
            : especialidade
        )
      );
    } catch (error) {
      console.error(
        'Erro ao atualizar status da especialidade de órgão:',
        error
      );
      alert(
        'Erro ao atualizar status da especialidade de órgão. Tente novamente.'
      );
    }
  };

  return (
    <div className="tabela-referencia-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Órgão de Especialidades</h1>
        </div>
        {!showForm && (
          <button 
            className="btn-primary"
            onClick={() => setShowForm(true)}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M12 5v14M5 12h14"/>
            </svg>
            Cadastrar Especialidade
          </button>
        )}
      </div>

      {showForm ? (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingId ? 'Editar Especialidade' : 'Cadastrar Especialidade'}</h2>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-group">
              <label htmlFor="especialidade">Especialidade *</label>
              <input
                type="text"
                id="especialidade"
                value={formData.especialidade}
                onChange={(e) => setFormData({...formData, especialidade: e.target.value})}
                required
                maxLength={100}
                placeholder="Digite a especialidade"
              />
            </div>

            <div className="form-group">
              <Toggle
                id="ativo"
                label="Status:"
                checked={formData.ativo}
                onChange={(e) => setFormData({...formData, ativo: e.target.checked})}
              />
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={resetForm}>
                Cancelar
              </button>
              <button type="submit" className="btn-primary">
                {editingId ? 'Atualizar' : 'Cadastrar'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="11" cy="11" r="8"/>
                <path d="M21 21l-4.35-4.35"/>
              </svg>
              <input
                type="text"
                placeholder="Pesquisar especialidades..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>{filteredOrgaoEspecialidades.length} registro(s) encontrado(s)</span>
            </div>
          </div>

          <div className="table-wrapper">
            <table className="data-table nucleos-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-nome">Especialidade</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredOrgaoEspecialidades.map(especialidade => (
                  <tr key={especialidade.id}>
                    <td>{especialidade.id}</td>
                    <td>{especialidade.especialidade}</td>
                    <td className="status-cell">
                      <div className="status-toggle-wrapper">
                        <Toggle
                          checked={especialidade.ativo}
                          onChange={() => handleToggleStatus(especialidade.id)}
                          id={`toggle-${especialidade.id}`}
                        />
                      </div>
                    </td>
                    <td className="col-acoes">
                      <div className="action-buttons">
                        <button 
                          className="btn-edit"
                          onClick={() => handleEdit(especialidade)}
                          title="Editar"
                        >
                          <FaEdit size={16} />
                        </button>
                        <button 
                          className="btn-delete"
                          onClick={() => handleDelete(especialidade.id)}
                          title="Excluir"
                        >
                          <FaTrash size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            {filteredOrgaoEspecialidades.length === 0 && (
              <div className="empty-state">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <circle cx="11" cy="11" r="8"/>
                  <path d="M21 21l-4.35-4.35"/>
                </svg>
                <h3>Nenhuma especialidade encontrada</h3>
                <p>Tente ajustar os filtros de pesquisa ou cadastre uma nova especialidade.</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default OrgaoEspecialidades;
